import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import SecurityIndustry from "@/pages/industries/SecurityIndustry";
export const Route = createFileRoute("/industries/security")({ head: ({match}) => pageHead(match.pathname), component: () => (<SecurityIndustry />) });
